import React from "react";
import { getBrowserLocale } from "../Utils/SupportUtils";

const SuccessErrorPage = ({ successPageStyle }) => {
  const language = getBrowserLocale();
  const message1 = successPageStyle
    ? successPageStyle.message[0][language]
    : "";
  const message2 = successPageStyle
    ? successPageStyle.message[1][language]
    : "";

  const messageColor = successPageStyle
    ? successPageStyle.messageColor
    : "inherit";
  return (
    <div
      style={{ textAlign: "center", marginTop: "100px", marginBottom: "100px" }}
    >
      <div>
        {successPageStyle && successPageStyle.icon && (
          <i
            className={`${successPageStyle.icon} fa-7x m-5`}
            style={{ color: successPageStyle.iconColor }}
          ></i>
        )}
        <h2 style={{ color: messageColor }}>{message1}</h2>
        <h4 style={{ color: messageColor }}>{message2}</h4>
      </div>
    </div>
  );
};

export default SuccessErrorPage;
